(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDetailController', TabObjectsDetailController);

    TabObjectsDetailController.$inject = ['$scope', '$rootScope', 'DataUtils','entity'];

    function TabObjectsDetailController($scope, $rootScope, DataUtils, entity) {
        var vm = this;
        vm.tabObjects = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabObjectsUpdate', function(event, result) {
            vm.tabObjects = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;


        vm.print = function(){
            var printContents = document.getElementById("toPrint").innerHTML;
            var popupWin = window.open('', '_blank', 'width=1024,height=900');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" href="content/css/vendor.css"><style>.col-lg-4{width: 33%; display: inline-block;}</style></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        };
    }
})();
